export default "__VITE_ASSET__9398d42b__"